import { useState, useEffect } from "react";
import axiosInstance from "services/httpInterceptor";

/**
 * Fetches topic frequency data from the v2 aggregation endpoint.
 * Returns clinical topic phrases (e.g. "Flow Diverters") not title tokens.
 *
 * Filtered to frequency >= 2 (single-article topics are noise) and
 * capped at 10 (a scrollable strip with 20 items is unusable).
 */
const usePressTopics = (selectedPress, selectedPresetKey) => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!selectedPresetKey) return;

    setLoading(true);
    const params = { preset: selectedPresetKey.toUpperCase(), limit: 30 };
    if (selectedPress) params.source = selectedPress;

    axiosInstance
      .get("/v1/news/v2/keywords/top", { params })
      .then((res) => {
        const meaningful = (res.data || [])
          .filter((t) => t.frequency >= 2)  // single-article topics are noise
          .slice(0, 10);                    // cap at 10 — strip is not a search index
        setTopics(meaningful);
      })
      .catch(() => setTopics([]))
      .finally(() => setLoading(false));
  }, [selectedPress, selectedPresetKey]);

  return { topics, loading };
};

export default usePressTopics;
